export default class infoCabecalho {
	titulo
	subtitulo
	slotName
	isCustom
	constructor(titulo, subtitulo, slotName, isCustom = false) {
		this.titulo = titulo
		this.subtitulo = subtitulo
		this.slotName = slotName
		this.isCustom = isCustom
	}
}
